import React, { Component } from 'react';
import { Alert, Card, CardBody, CardHeader } from 'reactstrap';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
            error: error,
            errorInfo: errorInfo
        });
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Card className="mt-5 border-danger">
                    <CardHeader className="bg-danger text-white">
                        <h4><i className="fa fa-exclamation-triangle mr-2" />Error en el Componente</h4>
                    </CardHeader>
                    <CardBody>
                        <Alert color="danger">
                            <strong>Mensaje:</strong> {this.state.error && this.state.error.toString()}
                        </Alert>
                        <details style={{ whiteSpace: 'pre-wrap', cursor: 'pointer' }}>
                            <summary className="text-muted mb-2">Ver detalles técnicos (Stack Trace)</summary>
                            <pre className="p-3 bg-light border">
                                {this.state.errorInfo && this.state.errorInfo.componentStack}
                            </pre>
                        </details>
                        <button 
                            className="btn btn-outline-danger mt-3" 
                            onClick={() => window.location.reload()}
                        >
                            Recargar Aplicación
                        </button>
                    </CardBody>
                </Card>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;